import React, {useEffect, useState} from 'react';
import './Verwaltung.css';
import NeuePerson from "../components/NeuePerson";
import NeueMannschaft from "../components/NeueMannschaft";
import NeuerVerein from "../components/NeuerVerein";
import Listen from "../Listen";

function Stammdaten(token) {
    const [updateList, setUpdateList] = useState(false);

    const handleUpdateListen = () => {
        setUpdateList((prevUpdate) => !prevUpdate);
    };

    useEffect(() => {
        console.log("Token in Stammdaten: ", token);
    }, [token]);

    if (!token) {
        return <p>No token provided</p>;
    }

    return (
        <div className="element-content element-background">
            <div className="grid-container-stammdaten">
                <div className="left-panel-verwaltung">
                    <NeuerVerein token={token} onUpdateList={handleUpdateListen}/>
                </div>
                <div className="right-panel-stammdaten">
                    <Listen request="verein" updateList={updateList}/>
                </div>
                <div className="left-panel-verwaltung">
                    <NeueMannschaft token={token} onUpdateList={handleUpdateListen}/>
                </div>
                <div className="right-panel-stammdaten">
                    <Listen request="mannschaft" updateList={updateList}/>
                </div>
                <div className="left-panel-verwaltung">
                    <NeuePerson token={token} onUpdateList={handleUpdateListen}/>
                </div>
                <div className="right-panel-stammdaten">
                    <Listen request="person" updateList={updateList}/>
                </div>
            </div>
        </div>
    );
}

export default Stammdaten;
